export default __webpack_public_path__ + "static/assets/3564d0621c282bcda1a7b0ce3a6a81bf.png";